import Vue from 'vue'
import Vuex from 'vuex'



import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    message: '',
    env: process.env,
    onXHR: false,
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    actions,
    mutations,
    modules: {
       
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js